// Base Vue library
import Vue, { PluginObject } from 'vue';
//import VeeValidate from 'vee-validate';
import store from './store/store';
import router from './routes';
import { Icon, FormItem, formatNumber, Table, WcDatepicker } from 'wc-lib'; 


// Custom application code below
import {App} from './app';


// Register global UI components
Vue.component('wc-icon', Icon);
Vue.component('wc-form-item', FormItem);
//Vue.component('wc-table', Table);
Vue.component('wc-datepicker', WcDatepicker);

import '../styles/styles.scss';

//Vue.use(VeeValidate as PluginObject<any>, { inject: false });

// Register global component
//Vue.component('sample', Sample);

new Vue({
  // Root vue element
  el: '#root',
  store,
  // Register root level router
  router: router,
  // Register local components
  components: {
    App
  }
})

require('./iframe/iframeResizer.contentWindow.min.js');




// WEBPACK FOOTER //
// src/main.ts